// src/pages/Home.tsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { userProfile, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  const modules = [
    {
      id: 'curadoria',
      title: 'Sistema de Curadoria Clínica',
      description: 'Rotulagem e análise de áudios cardíacos do dataset CirCor',
      icon: (
        <svg className="w-16 h-16" fill="currentColor" viewBox="0 0 20 20">
          <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
        </svg>
      ),
      path: '/curadoria',
      gradient: 'from-she-arterial-500 to-she-rosa-500',
      iconColor: 'text-she-arterial-600',
      hoverBorder: 'hover:border-she-arterial-300'
    },
    {
      id: 'shegpt',
      title: 'SHE GPT',
      description: 'Assistente de IA para análise e interpretação de dados cardíacos',
      icon: (
        <svg className="w-16 h-16" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd" />
        </svg>
      ),
      path: '/shegpt',
      gradient: 'from-she-venoso-500 to-she-arterial-500',
      iconColor: 'text-she-venoso-600',
      hoverBorder: 'hover:border-she-venoso-300'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-she">
      {/* Header */}
      <header className="bg-white shadow-md border-b border-she-palido-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <div className="w-12 h-11 flex items-center justify-center">
                {/* Logo SHE SVG */}
                <svg
                  className="w-full h-full"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 453.9 428.6"
                >
                  <g>
                    <path
                      fill="#8e162e"
                      d="M267,67.3c2.5,3.2,5.8,5.7,9.5,7.1,31.4,12.3,57.6,35,74.5,63.7,1.6,2.7,4.4,4.4,7.5,4.4h0c6.7,0,10.9-7.3,7.5-13.1-22.8-38.6-60.5-67.3-105.2-78.1-2.6-.6-4.5,2.4-2.9,4.4l9,11.5Z"
                    />
                    <path
                      fill="#8e162e"
                      d="M176.3,360.6c-2.1-2.7-4.9-4.6-8.1-5.9-29.6-11.3-54.8-31.7-72-57.8-1.6-2.5-4.4-4-7.3-4h0c-6.9,0-11.1,7.6-7.3,13.4,23.2,35.2,59.3,61.2,101.6,71.2s4.5-2.4,2.9-4.5l-9.7-12.4Z"
                    />
                    <path
                      fill="#8e162e"
                      d="M347,296.9c-17.7,26.8-43.7,47.6-74.4,58.7-1.1.4-2,1.1-2.7,2l-11.9,15.2c-1.6,2.1.3,5.1,2.9,4.4,41.9-10.1,77.7-36,100.8-71,3.8-5.7-.5-13.4-7.3-13.4h0c-3,0-5.7,1.5-7.3,4Z"
                    />
                    <path
                      fill="#8e162e"
                      d="M92.2,138.1c17.1-28.9,43.6-51.7,75.3-64,3.8-1.5,7.1-4,9.6-7.2l8.9-11.4c1.6-2.1-.3-5.1-2.9-4.5-45.1,10.6-83.1,39.5-106,78.3-3.4,5.8.8,13.1,7.5,13.1h0c3.1,0,5.9-1.7,7.5-4.4Z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#bd274a"
                      d="M223.8,178.9l74.9-48.2-50-64.1-15.1-19.4-1.3-1.7c-2.6-3.3-6.4-5-10.3-5-3.8,0-7.6,1.7-10.2,5l-1.3,1.6-15.1,19.3-50.7,64.7,74.3,47.8c1.5,1,3.4,1,4.9,0Z"
                    />
                    <path
                      fill="#bd274a"
                      d="M417.7,212.1l-31.7-30.9-20.3-19.8c-1.2-1.2-2.7-1.9-4.3-2.1-.4,0-.7-.1-1.1-.1-2.1,0-4.2.9-5.8,2.6l-16.8,19-32.1-41.1-69.7,60c-1.3,1.1-2.2,2.6-2.3,4.3l-8.5,109.6c-.1,1.8-1.7,3.3-3.5,3.3s-3.4-1.4-3.5-3.3l-9.1-109.7c-.1-1.7-1-3.3-2.3-4.3l-69.1-59.6-32,40.8-16.9-19.1c-1.5-1.7-3.6-2.6-5.8-2.6-.4,0-.8,0-1.1.1-1.5.2-3,.9-4.2,2.1l-20.3,19.8-31.7,30.9c-3.1,3-3.1,8,0,11l33.6,32.7,18.4,18c1.5,1.5,3.4,2.2,5.4,2.2s1.1,0,1.6-.2c1.6-.3,3-1.1,4.2-2.4l19.6-22.2,102.1,130.3,1.3,1.6c2.6,3.3,6.4,5,10.2,5s7.7-1.7,10.3-5l1.3-1.7,101.5-130.2,19.5,22c1.1,1.3,2.6,2.1,4.1,2.4.5.1,1.1.2,1.6.2,1.9,0,3.9-.7,5.4-2.2l18.4-17.9,33.6-32.8c3.1-3,3.1-8,0-11Z"
                    />
                  </g>
                </svg>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-she-venoso-900">
                  SHE Heart Lab
                </h1>
                <p className="text-sm text-gray-600">
                  Ambiente de Desenvolvimento e Pesquisa
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              {userProfile && (
                <div className="text-right">
                  <p className="text-sm font-medium text-she-venoso-900">
                    {userProfile.displayName || userProfile.email}
                  </p>
                  <span className="text-xs px-2 py-0.5 bg-she-palido-400 text-she-arterial-700 rounded-full font-medium">
                    {userProfile.role}
                  </span>
                </div>
              )}

              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-she-palido-300 text-she-venoso-700 rounded-lg hover:bg-she-palido-400 transition text-sm font-medium flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Sair
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-she-venoso-900 mb-4">
            Bem-vindo ao SHE Heart Lab
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Selecione a aplicação que deseja acessar
          </p>
        </div>

        {/* Module Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {modules.map((module) => (
            <button
              key={module.id}
              onClick={() => navigate(module.path)}
              className={`group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 border-she-palido-300 ${module.hoverBorder} transform hover:-translate-y-1`}
            >
              {/* Gradient Background on Hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${module.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>

              <div className="relative p-8">
                {/* Icon */}
                <div className={`w-20 h-20 mx-auto mb-6 ${module.iconColor} group-hover:scale-110 transition-transform duration-300`}>
                  {module.icon}
                </div>

                {/* Title */}
                <h3 className={`text-2xl font-bold text-she-venoso-900 mb-3 group-hover:bg-gradient-to-r group-hover:${module.gradient} group-hover:bg-clip-text group-hover:text-transparent transition-all duration-300`}>
                  {module.title}
                </h3>

                {/* Description */}
                <p className="text-gray-700 mb-6 leading-relaxed">
                  {module.description}
                </p>

                {/* Arrow Icon */}
                <div className={`flex items-center justify-center gap-2 ${module.iconColor} font-medium group-hover:gap-3 transition-all duration-300`}>
                  <span>Acessar aplicação</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </div>
              </div>

              {/* Bottom Accent Line */}
              <div className={`h-1 bg-gradient-to-r ${module.gradient} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300`}></div>
            </button>
          ))}
        </div>

        {/* Info Section */}
        <div className="mt-16 max-w-3xl mx-auto">
          <div className="bg-white border-2 border-she-palido-300 rounded-xl p-6 shadow-md">
            <div className="flex items-start gap-4">
              <svg className="w-6 h-6 text-she-arterial-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <div>
                <h4 className="text-lg font-semibold text-she-venoso-800 mb-2">
                  Sobre o SHE Heart Lab
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Ambiente interno de desenvolvimento e pesquisa para aplicações relacionadas à saúde cardiovascular.
                  Acesse o <strong className="text-she-arterial-600">Sistema de Curadoria Clínica</strong> para rotular e analisar áudios cardíacos do dataset CirCor,
                  ou utilize o <strong className="text-she-venoso-600">SHE GPT</strong> para obter insights e interpretações assistidas por IA.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;
